import en from './en'
import en_SA from './en-SA'
import en_US from './en-US'
import fr from './fr'
import iv from './iv'
import ar from './ar'
import ar_SA from './ar-SA'
import es from './es'
import it from './it'
import pt from './pt'

export const locales = {
  en,
  ['en-SA']: en_SA,
  ['en-US']: en_US,
  fr,
  iv,
  ar,
  ['ar-SA']: ar_SA,
  es,
  it,
  pt,
}

export default locales
